import React from 'react';
import { Modal } from 'react-bootstrap';

const UpdateDentalServiceDetails = ({ editDentalServiceModal, setEditDentalServiceModal, dentalServiceDetailsFormData, handleSubmitUpdateDentalServiceDetails, handleChangeDentalServiceFormData }) => {
    return (
        <>
            <Modal
                centered
                show={editDentalServiceModal}
                onHide={() => setEditDentalServiceModal(false)}
                size={"lg"}
            >
                <div className="modal-header">
                    <h3 className="modal-title" id="exampleModalLabel">Update Dental Service Details</h3>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={() => setEditDentalServiceModal(false)}
                    ></button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmitUpdateDentalServiceDetails}>
                        <div className="row">
                            <div className="col-xl-6">
                                <div className="form-group">
                                    <label htmlFor="serviceDetailName" className="col-form-label">
                                        Name:
                                    </label>
                                    <input
                                        name="serviceDetailName"
                                        value={dentalServiceDetailsFormData.dentalServiceName}
                                        onChange={(e) => handleChangeDentalServiceFormData(e)}
                                        type="text"
                                        className="form-control"
                                        placeholder="Dental Service Name"
                                        readOnly
                                    />
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="form-group">
                                    <label htmlFor="pt_price" className="col-form-label">
                                        Patient Price:
                                    </label>
                                    <input
                                        type="text"
                                        name="pt_price"
                                        value={dentalServiceDetailsFormData.pt_price}
                                        onChange={(e) => handleChangeDentalServiceFormData(e)}
                                        className="form-control"
                                        placeholder="Patient Price"
                                    />
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="form-group">
                                    <label htmlFor="client_price" className="col-form-label">
                                        Client Price:
                                    </label>
                                    <input
                                        type="text"
                                        name="client_price"
                                        value={dentalServiceDetailsFormData.client_price}
                                        onChange={(e) => handleChangeDentalServiceFormData(e)}
                                        className="form-control"
                                        placeholder="Client Price"
                                    />
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="form-group">
                                    <label htmlFor="client_price" className="col-form-label">
                                        Tax:
                                    </label>
                                    <input
                                        type="number"
                                        name="tax"
                                        value={dentalServiceDetailsFormData.tax}
                                        onChange={(e) => handleChangeDentalServiceFormData(e)}
                                        className="form-control"
                                        placeholder="Tax"
                                    />
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="form-group">
                                    <label htmlFor="status" className="col-form-label">
                                        Status:
                                    </label>
                                    <div className='d-flex align-items-center gap-4'>
                                        {["Active", "Inactive", "Deleted"].map((status) => (
                                            <div className="form-check me-3" key={status}>
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="status"
                                                    id={status.toLowerCase()}
                                                    value={status}
                                                    checked={dentalServiceDetailsFormData.status === status}
                                                    onChange={(e) => handleChangeDentalServiceFormData(e)}
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor={status.toLowerCase()}
                                                >
                                                    {status}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => setEditDentalServiceModal(false)}
                            >
                                Close
                            </button>
                            <button type="submit" className="btn btn-success">Update</button>
                        </div>
                    </form>
                </div>
            </Modal>
        </>
    )
};

export default UpdateDentalServiceDetails;